import { JSON_TABLE_INPUT_TYPE, SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";

const CreditOperatorFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "name": "fields",
                        "type": JSON_TABLE_INPUT_TYPE,
                        "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                        "trackValue": true,
                        "sizing": {
                            "sm": {
                                "size": 12,
                            },
                            "lg": {
                                "size": 10,
                                "offset": 1
                            }

                        },
                        "dataSchema": {
                            "required": {
                                "label": "Requerido",
                                "type": "checkbox",
                                "sizing": {
                                    "sm": {
                                        "offset": 2,
                                    }
                                },
                                "headingWidth": "col-2 col-xs-3",
                            },
                            "field_title": {
                                "label": "Description",
                                "type": "text",
                                "min": "0",
                                "trackValue": true,
                                "headingWidth": "col-5 col-xs-7",
                            },
                            "type": {
                                "label": "Tipo",
                                "type": SELECT_INPUT_TYPE,
                                "options": {
                                    "text": "Texto"
                                },
                                "headingWidth": "col-4 col-xs-3",
                            },
                            "showIndex": {
                                "label": "Mostrar en Lista",
                                "type": "checkbox",
                                "sizing": {
                                    "sm": {
                                        "offset": 2,
                                    }
                                },
                                "headingWidth": "col-2 col-xs-3",
                            },
                        },
                    },
                ],
            ]
        }
    ],
};


export default CreditOperatorFormConfig;